module.exports = __webpack_public_path__ + "assets/img/com.076b7caa.png";